import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { FeaturesRoutingModule } from './features-routing.module';
import { SharedModule } from '../shared/shared.module';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';

import { EqualValidator } from '../shared/validators/equal-validator.directive';
import { SearchComponent } from './search/search.component';
import { CompanyService } from './companies/company.service';
import { ContactService } from './contacts/contact.service';
import { SearchService } from './search/search.service';
import { AgmCoreModule } from '@agm/core';
import { TeamService } from './team/team.service';

@NgModule({
  declarations: [
    RegisterComponent,
    LoginComponent,
    LogoutComponent,
    EqualValidator,
    SearchComponent,
  ],
  providers: [
    SearchService,
    CompanyService,
    ContactService,
    TeamService
  ],
  imports: [
    CommonModule,
    SharedModule,
    // FeaturesRoutingModule -- hidden router so far,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    RegisterComponent,
    LoginComponent,
    LogoutComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FeaturesModule { }



// WEBPACK FOOTER //
// ./client/app/features/features.module.ts